module.exports = __webpack_public_path__ + "static/seo-hero.a247730f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/seo-hero.png
// module id = 944
// module chunks = 72138227098318